<ng-container *ngIf="uiTableModel.options?.virtualScroll; else normalContentLoad">
  <cdk-virtual-scroll-viewport
    [itemSize]="uiTableModel.options?.virtualScroll?.itemSize"
    [minBufferPx]="uiTableModel.options?.virtualScroll?.minBufferPx"
    [maxBufferPx]="uiTableModel.options?.virtualScroll?.maxBufferPx"
  >
    <table
      [ngClass]="{
        'ui-table': true,
        'ui-table--fixed': uiTableModel.hasEditableInput,
        'ui-table--dark': theme === 'DARK'
      }"
    >
      <ng-container *ngTemplateOutlet="tableHeader"></ng-container>
      <tbody>
        <ng-container *ngIf="uiTableModel.tableInfo.rows.length > 0; else emptyTable">
          <ng-container
            *cdkVirtualFor="let tableRow of uiTableModel.tableInfo.rows; let rowIndex = index; trackBy: trackByFn"
          >
            <ng-container
              *ngTemplateOutlet="tableRowTemplate; context: { tableRow: tableRow, rowIndex: rowIndex }"
            ></ng-container>
          </ng-container>
        </ng-container>
      </tbody>
      <ng-container *ngTemplateOutlet="tableFooter"></ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
</ng-container>

<ng-template #normalContentLoad>
  <table
    [ngClass]="{
      'ui-table': true,
      'ui-table--fixed': uiTableModel.hasEditableInput,
      'ui-table--dark': theme === 'DARK'
    }"
  >
    <ng-container *ngTemplateOutlet="tableHeader"></ng-container>
    <tbody>
      <ng-container *ngIf="uiTableModel.tableInfo.rows.length > 0; else emptyTable">
        <ng-container *ngFor="let tableRow of uiTableModel.tableInfo.rows; let rowIndex = index; trackBy: trackByFn">
          <ng-container
            *ngTemplateOutlet="tableRowTemplate; context: { tableRow: tableRow, rowIndex: rowIndex }"
          ></ng-container>
        </ng-container>
      </ng-container>
    </tbody>

    <ng-container *ngTemplateOutlet="tableFooter"></ng-container>
  </table>
</ng-template>

<ng-template #tableHeader>
  <thead *ngIf="uiTableModel.options?.grouppedHeaderConfig?.cells" class="ui-table__group-header">
    <tr>
      <ng-container *ngFor="let grouppedHeaderCell of uiTableModel.options?.grouppedHeaderConfig?.cells">
        <th [attr.colspan]="grouppedHeaderCell.span" class="ui-table__group-header--border">
          <ng-container
            [ngTemplateOutlet]="cellTemplate"
            [ngTemplateOutletContext]="{
              $implicit: {
                rowType: uiTableModel.options?.grouppedHeaderConfig?.type,
                cellInfo: grouppedHeaderCell
              }
            }"
          ></ng-container>
        </th>
      </ng-container>
    </tr>
  </thead>

  <thead
    [ngStyle]="{
      top: uiTableModel.options?.virtualScroll && translationOffsets.top
    }"
    class="ui-table__header"
  >
    <tr
      [ngClass]="{
        'ui-table__table-header-row': true,
        'ui-table__table-header-row--selected': uiTableModel.tableInfo.header.rowSelectionInfo?.isSelected
      }"
    >
      <ng-container *ngFor="let headerCell of uiTableModel.tableInfo.header.cells; let headerCellIndex = index">
        <th
          [style.width.px]="headerCell.widthInPx"
          [style.max-width.px]="headerCell.maxWidthInPx"
          [ngStyle]="{
            'left.px': headerCell.stickyType === 'LEFT' && headerCell.stickyPosition,
            'right.px': headerCell.stickyType === 'RIGHT' && headerCell.stickyPosition,
            height: getTableCellSize(cellSize)
          }"
          [ngClass]="{
            'table-header-row__cell': true,
            'table-header-row__cell--hidden': headerCell.isHidden,
            'table-header-row__cell--left': headerCell.stickyType === 'LEFT',
            'table-header-row__cell--right': headerCell.stickyType === 'RIGHT',
            'table-header-row__cell--SMALL': cellSize === 'SMALL',
            'table-header-row__cell--LARGE': cellSize === 'LARGE',
            'table-header-row__cell--border-right': headerCell.borderRight
          }"
        >
          <ng-container
            [ngTemplateOutlet]="cellTemplate"
            [ngTemplateOutletContext]="{
              $implicit: {
                rowType: uiTableModel.tableInfo.header.type,
                cellInfo: headerCell,
                tableRow: uiTableModel.tableInfo.header,
                cellIndex: headerCellIndex
              }
            }"
          ></ng-container>
        </th>
      </ng-container>
    </tr>
  </thead>
</ng-template>

<ng-template #tableRowTemplate let-tableRow="tableRow" let-rowIndex="rowIndex">
  <tr
    [ngClass]="{
      'ui-table__table-row': true,
      'ui-table__table-row--selected': tableRow.rowSelectionInfo?.isSelected
    }"
    [ngStyle]="{ height: uiTableModel.options?.virtualScroll?.itemSize + 'px' }"
  >
    <td
      *ngFor="let child of tableRow.cells; let cellIndex = index; trackBy: trackCellByFn"
      [style.min-width.px]="child.widthInPx"
      [style.max-width.px]="child.maxWidthInPx"
      [ngStyle]="{
        'left.px': child.stickyType === 'LEFT' && child.stickyPosition,
        'right.px': child.stickyType === 'RIGHT' && child.stickyPosition,
        height: getTableCellSize(cellSize),
        'text-align': child.align,
        overflow:
          child.cellInfo && child.cellInfo.type === 'TEXT_LIST_CELL' && child.cellInfo.animate ? 'auto' : 'visible'
      }"
      [style.vertical-align]="cellTextAlign"
      [ngClass]="{
        'table-row__cell': true,
        'table-row__cell--hidden': child.isHidden,
        'table-row__cell--left': child.stickyType === 'LEFT',
        'table-row__cell--right': child.stickyType === 'RIGHT',
        'table-row__cell--SMALL': cellSize === 'SMALL',
        'table-row__cell--LARGE': cellSize === 'LARGE',
        'table-row__cell--border-right': uiTableModel.tableInfo.header.cells[cellIndex].borderRight
      }"
    >
      <ng-container *ngIf="tableRow.type !== 'ROW'">
        <div class="cell__input" *ngFor="let inps of [tableRow.formModel.inputs[cellIndex]]; trackBy: trackByFn">
          <ng-container *ngIf="!inps.metadata.isHidden">
            <div *ngIf="inps.input.type === 'DROPDOWN_WITH_SEARCH'">
              <monorepo-multi-select-dropdown
                [dropdownConfig]="{
                  isMultiSelect: inps.input.isMulti || false,
                  placeHolder: inps.input.placeholder | translate,
                  isDisabled: inps.metadata.isDisabled || false,
                  isClearOption: inps.input.isClearOption || false
                }"
                [dropdownData]="{ items: inps.input.options || [], defaultSelectedItems: inps.input.value }"
                (selectedList)="onDropdownListSelection($event, inps, cellIndex, rowIndex)"
              ></monorepo-multi-select-dropdown>
            </div>
            <div *ngIf="inps.input.type === 'DROPDOWN'">
              <!-- .toString() added for localization. | translate only takes string -->
              <div [style.padding-bottom.px]="5" [style.font-size.px]="12" [style.color]="'#717171'">
                {{ inps.metadata.label ? (inps.metadata.label.toString() | translate) : inps.metadata.label }}
              </div>
              <ion-select
                class="ion-text-left"
                interface="popover"
                [interfaceOptions]="{
                  size: 'auto',
                  showBackdrop: false,
                  cssClass: 'base-table-multi-select-dropdown'
                }"
                placeholder="{{ inps.input.placeholder | translate }}"
                [value]="inps.input.subType === 'number' ? inps.input.value + '' : inps.input.value"
                [disabled]="inps.metadata.isDisabled"
                [multiple]="inps.input.isMulti"
                (ionChange)="onChange($event, inps, cellIndex, rowIndex)"
              >
                <ion-select-option *ngFor="let item of inps.input.options" value="{{ item.value }}">
                  {{ item.displayName || item.value | translate }}
                </ion-select-option>
              </ion-select>

              <div *ngIf="inps.input.inputValueForOtherOption">
                <ion-input
                  placeholder="Other"
                  [value]="inps.input.inputValueForOtherOption.input.value"
                  (ionChange)="onChange($event, inps, cellIndex, rowIndex, true)"
                >
                </ion-input>

                <div
                  *ngIf="
                    !inps.input.inputValueForOtherOption.metadata.isValid &&
                    inps.input.inputValueForOtherOption.metadata.isTouched
                  "
                  class="form__invalid-msg"
                >
                  <span>{{ 'table_model.invalidError' | translate }} </span><span>{{ inps.metadata.keyName }}</span>
                </div>
              </div>

              <div *ngIf="!inps.metadata.isValid && inps.metadata.isTouched" class="form__invalid-msg">
                <span>{{ 'table_model.invalidError' | translate }} </span><span>{{ inps.metadata.keyName }}</span>
              </div>
            </div>

            <div *ngIf="inps.input.type === 'INPUT'">
              <div *ngIf="!inps.metadata.isReadonly; else inputNonEditable">
                <div [style.padding-bottom.px]="5" [style.font-size.px]="12" [style.color]="'#717171'">
                  {{ inps.metadata.label | translate }}
                </div>
                <ion-input
                  [id]="inps.metadata.keyName"
                  [type]="inps.input.subType"
                  [value]="inps.input.value"
                  [disabled]="inps.metadata.isDisabled"
                  [placeholder]="inps.input.placeholder | translate"
                  [min]="inps.input.min"
                  [max]="inps.input.max"
                  (ionChange)="onChange($event, inps, cellIndex, rowIndex)"
                >
                </ion-input>
                <div *ngIf="!inps.metadata.isValid && inps.metadata.isTouched" class="form__invalid-msg">
                  <span>{{ 'table_model.invalidError' | translate }} </span><span>{{ inps.metadata.keyName }}</span>
                </div>
              </div>
              <ng-template #inputNonEditable>
                <div class="monorepo-form__non-editable-field">{{ inps.input.value }}</div>
              </ng-template>
            </div>

            <div *ngIf="inps.input.type === 'CHECKBOX'">
              <div>
                <div [style.padding-bottom.px]="5" [style.font-size.px]="12" [style.color]="'#717171'">
                  {{ inps.metadata.label | translate }}
                </div>
                <ion-checkbox
                  [mode]="'ios'"
                  class="ui-table__select-cell ui-table__select-cell--isMulti"
                  [ngClass]="{
                    'ui-table__select-cell--LARGE': cellSize === 'LARGE'
                  }"
                  [checked]="inps.input.checked"
                  [disabled]="inps.input.disabled"
                  (ionChange)="onChange($event, inps, cellIndex, rowIndex)"
                ></ion-checkbox>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container
        *ngIf="tableRow.type === 'ROW' || tableRow.formModel.inputs[cellIndex].input.type === 'EMPTY'"
        [ngTemplateOutlet]="cellTemplate"
        [ngTemplateOutletContext]="{
          $implicit: {
            rowType: tableRow.type,
            cellInfo: child,
            tableRow: tableRow,
            rowIndex: rowIndex,
            cellIndex: cellIndex
          }
        }"
      ></ng-container>
    </td>
  </tr>
</ng-template>

<ng-template #tableFooter>
  <!--TODO: move it span structure, move it option-->
  <tfoot
    *ngIf="uiTableModel.tableInfo.footer"
    [ngStyle]="{
      bottom: uiTableModel.options?.virtualScroll && translationOffsets.bottom
    }"
  >
    <tr
      [ngClass]="{
        'ui-table__table-footer-row': true
      }"
    >
      <ng-container *ngFor="let footerCell of uiTableModel.tableInfo.footer?.cells; let footerCellIndex = index">
        <th
          [style.width.px]="footerCell.widthInPx"
          [style.max-width.px]="footerCell.maxWidthInPx"
          [ngStyle]="{
            'left.px': footerCell.stickyType === 'LEFT' && footerCell.stickyPosition,
            'right.px': footerCell.stickyType === 'RIGHT' && footerCell.stickyPosition,
            height: getTableCellSize(cellSize)
          }"
          [ngClass]="{
            'table-footer-row__cell': true,
            'table-footer-row__cell--hidden': footerCell.isHidden,
            'table-footer-row__cell--left': footerCell.stickyType === 'LEFT',
            'table-footer-row__cell--right': footerCell.stickyType === 'RIGHT',
            'table-footer-row__cell--SMALL': cellSize === 'SMALL',
            'table-footer-row__cell--LARGE': cellSize === 'LARGE',
            'table-footer-row__cell--border-right': footerCell.borderRight
          }"
        >
          <ng-container
            [ngTemplateOutlet]="cellTemplate"
            [ngTemplateOutletContext]="{
              $implicit: {
                rowType: uiTableModel.tableInfo.footer.type,
                cellInfo: footerCell,
                tableRow: uiTableModel.tableInfo.footer
              }
            }"
          ></ng-container>
        </th>
      </ng-container>
    </tr>
  </tfoot>
</ng-template>

<ng-template #emptyTable>
  <tr>
    <!-- TODO[Anubhav]: add column length in model -->
    <ng-container *ngIf="uiTableModel.tableInfo.header && !omitEmptyTableTemplate">
      <td [attr.colspan]="uiTableModel.tableInfo.header.cells.length">
        <div class="ui-table__no-results">
          <div>
            <img [src]="'assets/common/no-data-icon.svg'" />
          </div>
          <div class="ui-table__no-results-title">{{ emptyTableText | translate }}</div>
          <div *ngIf="showClickOnPlusMsg" class="ui-table__no-results-subtxt">
            {{ 'table_model.addaRow' | translate }}
          </div>
        </div>
      </td>
    </ng-container>
  </tr>
</ng-template>

<ng-template #cellTemplate let-cellTemplateData>
  <!-- Making CellData typesafe -->
  <ng-container *ngFor="let cell of [typedCellNode(cellTemplateData)]; trackBy: trackByFn">
    <!-- Select Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'SELECT_CELL' && cell.cellInfo.isVisible">
      <div
        class="ui-table__select-wrapper"
        (click)="cell.rowType === 'ROW' ? toggleRowSelection($event, cell.rowIndex) : toggleHeaderSelection($event)"
      >
        <ng-container *ngIf="cell.rowType === 'ROW' && cell.tableRow.rowSelectionInfo?.disabledReason">
          <span class="select-cell-info" [id]="'select-info-' + cell.rowIndex">
            <img src="assets/icon/common/info.svg" />
          </span>
          <ion-popover mode="ios" [trigger]="'select-info-' + cell.rowIndex" triggerAction="hover" showBackdrop="false">
            <ng-template>
              <ion-content class="ion-padding select-cell-info-popover">{{
                cell.tableRow.rowSelectionInfo?.disabledReason
              }}</ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>

        <ion-checkbox
          [mode]="'ios'"
          class="ui-table__select-cell"
          [ngClass]="{
            'ui-table__select-cell--isMulti': cell.cellInfo.isMulti,
            'ui-table__select-cell--LARGE': cellSize === 'LARGE'
          }"
          [checked]="cell.cellInfo.isChecked"
          [disabled]="!!cell.tableRow.rowSelectionInfo?.isDisabled"
          [indeterminate]="cell.cellInfo.isIntermediate"
        ></ion-checkbox>
      </div>
    </ng-container>

    <!-- Text Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'TEXT_CELL'">
      <div
        [ngClass]="[
          'text-cell',
          cell.cellInfo.textColor ? 'cell-text-color--' + cell.cellInfo.textColor : '',
          cell.cellInfo.align === 'left' ? 'text-cell--align-left' : '',
          cell.cellInfo.align === 'center' ? 'text-cell--align-center' : '',
          cell.cellInfo.verticalAlign == 'middle' ? 'text-cell--vertical-align-middle' : '',
          cell.cellInfo.align === 'right' ? 'text-cell--align-right' : '',
          cell.cellInfo.textOverflow === 'nowrap' ? 'text-cell--overflow-nowrap' : ''
        ]"
        [ngStyle]="{
          'font-size': getSizeStringFromCssSize(cell.cellInfo.fontSize)
        }"
        (click)="checkIfExternalInputFieldAndSendEvent(cell)"
      >
        <ng-container *ngIf="cell.cellInfo.icon?.align === 'START'">
          <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="cellMarkerTemplate; context: { marker: cell.cellInfo.marker }"></ng-container>

        <ng-container *ngIf="cell.cellInfo.href">
          <div
            [routerLink]="cell.cellInfo.href"
            [queryParams]="cell.cellInfo.queryParams"
            [state]="cell.cellInfo.navigationState"
            class="text-cell--link"
          >
            {{ cell.cellInfo.text ? (cell.cellInfo.text.toString() | translate) : cell.cellInfo.text }}
          </div>
        </ng-container>
        <ng-container *ngIf="cell.cellInfo.hrefActionCB && cell.tableRow.type === 'ROW'">
          <div
            [ngClass]="[cell.cellInfo.textColor ? 'cell-text-color--' + cell.cellInfo.textColor : '']"
            class="text-cell--link"
            (click)="
              onLinkClicked.emit({
                rowItem: cell.tableRow.rowItem,
                linkClicked: cell.cellInfo.hrefActionCB,
                event: $event
              })
            "
          >
            {{ cell.cellInfo.text ? (cell.cellInfo.text.toString() | translate) : cell.cellInfo.text }}
          </div>
        </ng-container>

        <span
          *ngIf="cell.cellInfo.text !== '' && !cell.cellInfo.href && !cell.cellInfo.hrefActionCB"
          [ngClass]="[cell.cellInfo.isExternalInput?.editStatus ? 'text-cell--selectedBorderActive' : '']"
        >
          <ng-container *ngIf="cell.cellInfo.preTagForDataDisplay; else noPreTagForDataDisplay">
            <pre>{{ cell.cellInfo.text ? (cell.cellInfo.text.toString() | translate) : cell.cellInfo.text }}</pre>
          </ng-container>
          <ng-template #noPreTagForDataDisplay>
            {{ cell.cellInfo.text ? (cell.cellInfo.text.toString() | translate) : cell.cellInfo.text }}
          </ng-template>
        </span>

        <div
          *ngIf="cell.cellInfo.subtitle"
          [style.font-size]="getSizeStringFromCssSize(cell.cellInfo.subtitle.fontSize)"
          [ngClass]="[
            cell.cellInfo.subtitle.align === 'INLINE' ? 'inline-text' : '',
            cell.cellInfo.align === 'left' ? 'text-cell--align-left' : '',
            cell.cellInfo.align === 'center' ? 'text-cell--align-center' : '',
            cell.cellInfo.align === 'right' ? 'text-cell--align-right' : '',
            cell.cellInfo.subtitle.textColor
              ? 'cell-text-color--' + cell.cellInfo.subtitle.textColor
              : 'subtitle__default-color'
          ]"
          class="subtitle"
        >
          {{ cell.cellInfo.subtitle.text | translate }}
        </div>

        <ng-container *ngIf="cell.cellInfo.tag && cell.rowType === 'ROW'">
          <span
            [id]="'row-' + cell.rowIndex + '-' + cell.cellIndex"
            class="cell-tag"
            [ngClass]="[
              cell.cellInfo.tag.tagBgColor ? 'cell-tag--' + cell.cellInfo.tag.tagBgColor : '',
              cell.cellInfo.text !== '' ? 'cell-tag--left-margin' : ''
            ]"
            >{{
              cell.cellInfo.tag.tagContent
                ? (cell.cellInfo.tag.tagContent.toString() | translate)
                : cell.cellInfo.tag.tagContent
            }}</span
          >
          <ion-popover
            *ngIf="cell.cellInfo.tag.tagTooltipContent"
            mode="ios"
            [trigger]="'row-' + cell.rowIndex + '-' + cell.cellIndex"
            [triggerAction]="cell.cellInfo.tag.showTooltipEvent"
            showBackdrop="false"
            class="table-cell-tag"
          >
            <ng-template>
              <ion-content class="ion-padding cell-tag-popover">{{ cell.cellInfo.tag.tagTooltipContent }}</ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>
        <ng-container *ngIf="cell.cellInfo.icon?.align === 'END'">
          <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </ng-container>
      </div>

      <ng-template #iconTemplate>
        <ng-container [ngSwitch]="cell.cellInfo.icon?.type">
          <ng-container *ngSwitchCase="'UP'">
            <ion-icon name="arrow-up-outline"></ion-icon>
          </ng-container>
          <ng-container *ngSwitchCase="'DOWN'">
            <ion-icon name="arrow-down-outline"></ion-icon>
          </ng-container>
          <ng-container *ngSwitchCase="'WARNING'">
            <ion-icon name="alert-outline"></ion-icon>
          </ng-container>
          <ng-container *ngSwitchCase="'SORT'">
            <ion-icon
              *ngIf="cell.rowType === 'HEADER_ROW' && uiTableModel.options?.sort"
              (click)="sortTableByComunIndex(cell.cellIndex)"
              class="table-header-row__cell--sort-icon"
              name="swap-vertical-outline"
            ></ion-icon>
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-container>

    <!-- Text List Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'TEXT_LIST_CELL'">
      <div
        [ngClass]="{ 'text-list-cell__item': true, 'text-list-cell__item--animate': cell.cellInfo.animate }"
        [ngStyle]="{
          'background-color': cell.cellInfo.background,
          'justify-content': cell.cellInfo.textAlign,
          'text-align': cell.cellInfo.textAlign,
          height: cell.cellInfo.fullHeight ? '100%' : 'unset',
          overflow: 'hidden',
          display: 'flex',
          'flex-direction': cell.cellInfo.orientation === 'HORIZONTAL' ? 'row' : 'column',
          gap: getSizeStringFromCssSize(cell.cellInfo.gap),
          'animation-duration': cell.cellInfo.cssAnimationDuration ?? '10s',
          'flex-wrap': cell.cellInfo.flexWrap ?? 'nowrap'
        }"
      >
        <div
          *ngFor="let text of cell.cellInfo.text; let i = index"
          [ngClass]="[
            cell.cellInfo.textColor && cell.cellInfo.textColor[i]
              ? 'cell-text-color--' + cell.cellInfo.textColor[i]
              : ''
          ]"
          [ngStyle]="{
            'font-size': getSizeStringFromCssSize(cell.cellInfo.fontSize),
            'white-space': cell.cellInfo.textOverflow && cell.cellInfo.textOverflow === 'nowrap' ? 'nowrap' : 'normal',
            'color': (cell.cellInfo.textColorHexCodes && cell.cellInfo.textColorHexCodes[i]) ? cell.cellInfo.textColorHexCodes[i]: '',
          }"
        >
          {{ text.toString() | translate }}
          <div
            *ngIf="cell.cellInfo.subtitle && cell.cellInfo.subtitle.text"
            [style.font-size.px]="cell.cellInfo.subtitle.fontSizeInPx"
            [ngClass]="{ 'inline-text': cell.cellInfo.subtitle.align === 'INLINE' }"
            class="subtitle"
          >
            {{ cell.cellInfo.subtitle.text[i] | translate }}
          </div>
        </div>
        <div *ngIf="cell.cellInfo.text.length === 0">--</div>
        <ng-container *ngTemplateOutlet="cellMarkerTemplate; context: { marker: cell.cellInfo.marker }"></ng-container>
      </div>
    </ng-container>

    <!-- Tag List Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'TAG_LIST_CELL'">
      <monorepo-tag-display [tags]="cell.cellInfo.tags"></monorepo-tag-display>
    </ng-container>

    <!-- User Text Input Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'USER_TEXT_INPUT_CELL'">
      <input [(ngModel)]="cell.cellInfo.value" (ngModelChange)="updateUserInputCell()" />
    </ng-container>

    <!-- Add Row Cell -->
    <ng-container *ngIf="cell.rowType === 'ADD_ROW' && cell.cellInfo.type === 'EDIT_ROW'">
      <div class="edit__row">
        <img
          *ngIf="!uiTableModel.options?.edit?.isMulti && !uiTableModel.options?.edit?.isEditOnly"
          (click)="saveEditRow(cell.tableRow, 0)"
          src="assets/common/table/ic-save.svg"
        />
        <img (click)="removeRow(cell.rowIndex)" src="assets/common/table/ic-reset.svg" />
      </div>
    </ng-container>

    <ng-container *ngIf="cell.cellInfo.type === 'EDIT_ROW' && cell.rowType === 'HEADER_ROW' && cell.cellInfo.hasAddRow">
      <div class="add-row" (click)="addRow()">
        <img src="assets/common/table/ic-add.svg" />
        <span class="add-row__text">{{ 'table_model.Row' | translate }}</span>
      </div>
    </ng-container>

    <!-- Edit Row Cell -->
    <ng-container
      *ngIf="cell.rowType !== 'HEADER_ROW' && cell.rowType !== 'ADD_ROW' && cell.cellInfo.type === 'EDIT_ROW'"
    >
      <div class="edit__row">
        <img
          *ngIf="cell.rowType === 'ROW' && !uiTableModel.options?.edit?.disableEdit"
          (click)="editRow(cell.rowIndex)"
          src="assets/common/table/ic-edit.svg"
        />
        <img
          *ngIf="cell.rowType === 'ROW' && cell.cellInfo.hasDeleteRow"
          (click)="deleteRow(cell.rowIndex)"
          src="assets/common/table/ic-delete.svg"
        />
        <img
          *ngIf="
            cell.rowType !== 'ROW' && !uiTableModel.options?.edit?.isMulti && !uiTableModel.options?.edit?.isEditOnly
          "
          (click)="saveEditRow(cell.tableRow, cell.rowIndex)"
          src="assets/common/table/ic-save.svg"
        />
        <img
          *ngIf="cell.rowType !== 'ROW' && !uiTableModel.options?.edit?.isEditOnly"
          class="edit-cell"
          (click)="closeEditRow(cell.rowIndex)"
          src="assets/common/table/ic-reset.svg"
        />
      </div>
    </ng-container>

    <!-- Action Cell -->
    <ng-container
      *ngIf="
        cell.cellInfo.type === 'ACTION_CELL' &&
        (cell.tableRow.type === 'ROW' || cell.tableRow.type === 'EDIT_ROW') &&
        (cell.rowType === 'ROW' ||
          (uiTableModel.options?.edit?.showActionCellsInEditMode && cell.rowType === 'EDIT_ROW')) &&
        !cell.cellInfo.isDisabled
      "
    >
      <ion-text
        *ngIf="!cell.cellInfo.asIcon && !cell.cellInfo.customIconPath"
        class="cell__view"
        [ngStyle]="{
          opacity: cell.cellInfo.actionNotAllowed ? '0.3' : '1',
          cursor: cell.cellInfo.actionNotAllowed ? 'not-allowed' : 'pointer',
          'align-items': cellTextAlign === 'top' ? 'flex-start' : 'center'
        }"
        (click)="rowAction($event, cell.tableRow.rowItem, cell.cellInfo.actionType, cell.cellInfo, cell.rowIndex)"
      >
        <ng-container *ngIf="!cell.cellInfo.customTxt; else customTxtIcon">{{
          cell.cellInfo.actionName ? (cell.cellInfo.actionName | translate) : cell.cellInfo.actionType
        }}</ng-container>
        <ng-template #customTxtIcon>{{
          cell.cellInfo.customTxt ? (cell.cellInfo.customTxt | translate) : cell.cellInfo.customTxt
        }}</ng-template>
      </ion-text>
      <ng-container *ngIf="cell.cellInfo.customIconPath">
        <div
          class="row-custom-icon"
          (click)="rowAction($event, cell.tableRow.rowItem, cell.cellInfo.actionType, cell.cellInfo, cell.rowIndex)"
        >
          <img [src]="cell.cellInfo.customIconPath" />
        </div>
      </ng-container>
      <ng-container *ngIf="cell.cellInfo.asIcon">
        <div
          [id]="'action-cell-' + cell.cellInfo.actionType + cell.rowIndex"
          class="row-icon"
          [ngClass]="{
            'row-icon--SMALL' : !cell.cellInfo.showLargeIcon,
            'row-icon--LARGE' : cell.cellInfo.showLargeIcon,
          }"
          (click)="rowAction($event, cell.tableRow.rowItem, cell.cellInfo.actionType, cell.cellInfo, cell.rowIndex)"
        >
          <img *ngIf="cell.cellInfo.actionType === 'VIEW'" src="assets/common/view-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'ARCHIVE_USER'" src="assets/common/archive-user.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'EDIT'" src="assets/common/edit-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'DELETE'" src="assets/common/delete-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'TRANSFER'" src="assets/common/transfer-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'NAVIGATE'" src="assets/common/navigate-right-arrow-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'INFO'" src="assets/common/info-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'ASSIGN'" src="assets/common/assign-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'UNDO'" src="assets/common/undo-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'UPLOAD'" src="assets/common/upload-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'COPY'" src="assets/common/copy-icon.svg" />
          <img *ngIf="cell.cellInfo.actionType === 'IS_RECALIBRATED'" src="assets/common/blue-down-arrow-filled.svg" />
          <ion-icon *ngIf="cell.cellInfo.actionType === 'CHART'" [style.color]="'#05C3DD'" name="bar-chart-outline">
          </ion-icon>
        </div>
        <ion-popover
          *ngIf="cell.cellInfo.hoverText"
          mode="ios"
          [trigger]="'action-cell-' + cell.cellInfo.actionType + cell.rowIndex"
          triggerAction="hover"
          showBackdrop="false"
        >
          <ng-template>
            <ion-content class="ion-padding action-cell-info-popover">{{ cell.cellInfo.hoverText }}</ion-content>
          </ng-template>
        </ion-popover>
      </ng-container>
    </ng-container>

    <!-- Empty Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'EMPTY_CELL'"></ng-container>

    <!-- Error Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'ERROR_CELL'">
      <div class="cell-error">{{ 'table_model.Err' | translate }}</div>
    </ng-container>

    <!-- Action List Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'ACTION_LIST_CELL' && cell.rowType === 'ROW'">
      <div (click)="showActionListPopover($event, cell.cellInfo, cell.tableRow.rowItem)" class="action-list-cell">
        <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
      </div>
    </ng-container>

    <!-- Button Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'BUTTON_CELL' && cell.rowType === 'ROW'">
      <div>
        <ui-custom-button
          [btnTxt]="cell.cellInfo.btnText | translate"
          (clickEvent)="onButtonCLick.emit(cell.tableRow.rowItem)"
          [isDisabled]="cell.cellInfo.isDisabled || false"
        ></ui-custom-button>
      </div>
    </ng-container>

    <!-- Toggle Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'TOGGLE_CELL' && cell.rowType === 'ROW'">
      <div>
        <ion-toggle
          [id]="'row-' + cell.rowIndex + '-' + cell.cellIndex"
          [checked]="cell.cellInfo.checked"
          [disabled]="cell.cellInfo.isDisabled"
          (click)="
            cell.cellInfo.isDisabled
              ? $event.stopImmediatePropagation()
              : onToggleChange($event, cell.tableRow.rowItem, cell.rowIndex, cell.cellInfo.preventDefaults)
          "
        ></ion-toggle>

        <ion-popover
          *ngIf="cell.cellInfo.tooltipContent !== ''"
          mode="ios"
          side="top"
          alignment="start"
          [trigger]="'row-' + cell.rowIndex + '-' + cell.cellIndex"
          triggerAction="hover"
          showBackdrop="false"
          class="table-cell-tag"
        >
          <ng-template>
            <ion-content class="ion-padding cell-tag-popover">{{ cell.cellInfo.tooltipContent }}</ion-content>
          </ng-template>
        </ion-popover>
      </div>
    </ng-container>

    <!-- Toggle with Label Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'LABELLED_TOGGLE_CELL' && cell.rowType === 'ROW'">
      <div
        class="labelled-toggle-container"
        [ngClass]="{ 'labelled-toggle-container--disabled': cell.cellInfo.isDisabled }"
      >
        <div
          *ngFor="let option of cell.cellInfo.options | keyvalue"
          (click)="toggleCell(option.value.value, cell.rowIndex, cell.cellIndex)"
          class="labelled-toggle-cell"
          [ngClass]="{ 'labelled-toggle-cell--selected': cell.cellInfo.selectedValue === option.value.value }"
        >
          {{ option.value.label | translate }}
        </div>
      </div>
    </ng-container>

    <!-- Checkbox Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'CHECKBOX_CELL' && cell.rowType === 'ROW'">
      <div>
        <ion-checkbox
          [mode]="'ios'"
          class="ui-table__select-cell ui-table__select-cell--isMulti"
          [ngClass]="{
            'ui-table__select-cell--LARGE': cellSize === 'LARGE'
          }"
          [checked]="cell.cellInfo.checked"
          [disabled]="cell.cellInfo.disabled"
        ></ion-checkbox>
      </div>
    </ng-container>

    <!-- IMAGE Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'IMAGE_CELL' && cell.rowType === 'ROW' && cell.cellInfo.images.length">
      <div class="imageContainer">
        <ng-container *ngIf="cell.cellInfo.areImagesHidden; else imageTemplate">
          <ion-button (click)="showImage(cell.rowIndex, cell.cellIndex)">{{
            'table_model.show' | translate
          }}</ion-button>
        </ng-container>
      </div>
      <ng-template #imageTemplate>
        <ng-container *ngFor="let image of cell.cellInfo.images">
          <img [style.width.px]="image.widthInPx" [style.height.px]="image.heightInPx" [src]="image.src" />
        </ng-container>
        <ion-button (click)="hideImage(cell.rowIndex, cell.cellIndex)">{{ 'table_model.hide' | translate }}</ion-button>
      </ng-template>
    </ng-container>

    <!-- Progress Bar Cell -->
    <ng-container *ngIf="cell.cellInfo.type === 'PROGRESS_BAR_CELL'">
      <div style="display: flex; gap: 4px; align-items: center">
        <span *ngIf="cell.cellInfo.fractionText">{{ cell.cellInfo.fractionText }}</span>
        <ion-progress-bar
          [value]="cell.cellInfo.value"
          [color]="cell.cellInfo.color || 'primary'"
          [type]="cell.cellInfo.indeterminate ? 'indeterminate' : 'determinate'"
        ></ion-progress-bar>
        <span *ngIf="!cell.cellInfo.fractionText">{{ (cell.cellInfo.value * 100).toFixed(2) }}%</span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #cellMarkerTemplate let-marker="marker">
  <div
    *ngIf="marker"
    class="marker"
    [ngStyle]="{
      'background-color': marker.color,
      'min-width': getMarkerCustomSize(marker, 'width'),
      'max-width': getMarkerCustomSize(marker, 'width'),
      height: getMarkerCustomSize(marker, 'height')
    }"
  >
    <span *ngIf="marker.iconId === 'RED_PATTERN'">
      <img src="assets/common/timeline/red-critical.svg" />
    </span>
    <span *ngIf="marker.iconId === 'YELLOW_PATTERN'">
      <img src="assets/common/timeline/yellow-critical.svg" />
    </span>
    <span *ngIf="marker.iconId === 'IN_PROGRESS'">
      <img src="assets/common/timeline/in-progress-marker.svg" />
    </span>
    <span *ngIf="marker.iconId === 'LOADING'">
      <img src="/assets/input-app/loading.svg" />
    </span>
    <span *ngIf="marker.iconId === 'GREEN_UP_ARROW'">
      <img src="/assets/input-app/green-up-arrow.svg" />
    </span>
    <span *ngIf="marker.iconId === 'RED_DOWN_ARROW'">
      <img src="/assets/input-app/red-down-arrow.svg" />
    </span>
  </div>
</ng-template>
